import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../../messages';
import { useFulfillmentPlannerContext } from '../../../../fulfillment-planner/context';

import style from './style.module.less';

export const RateError = () => {
  const { rateErrors, labelCreationErrors, didLabelCreationFail } = useFulfillmentPlannerContext();
  const errorMessages = didLabelCreationFail ? labelCreationErrors : rateErrors;
  const errorMessage = errorMessages[0] || messages.unexpected;
  return (
    <div className={style['error-wrapper']}>
      <FontAwesomeIcon icon={faExclamationTriangle} />
      <div className={style.title}>
        <FormattedMessage {...messages.rateErrorTitle} />
      </div>
      <div className={style.message}>{typeof errorMessage === 'string' ? errorMessage : <FormattedMessage {...errorMessage} />}</div>
    </div>
  );
};
